
import React, { useState, useEffect } from 'react';
import '../../styles/TabSwitcher.scss';
import axios from 'axios';
import copy from '../../resources/copy.svg'
import { CopyToClipboard } from 'react-copy-to-clipboard';

import { message } from 'antd';
import '../../styles/antd-message.scss';


message.config({
  top:100,
  duration:2
})

const CopySuccess = () => {
  message.success('Copied', 1);
};


function OffChainTab() {
    const [isLoading, setIsLoading] = useState(false)
    const [httpsLink, setHttpsLink] = React.useState('https://qrng.dorafactory.org/faucet-api/');
    const [wssLink, setWssLink] = React.useState('wss://qrng.dorafactory.org/faucet-ws/');
    const [page, setPage] = React.useState(0);
    const [totalCount, setTotalCount] = React.useState(0);
    const [totalPage, setTotalPage] = React.useState(0);
    const [limit, setLimit] = React.useState(10);
    const [requestHistory, setRequestHistory] = React.useState([]);
    const [randomCount, setRandomCount] = React.useState(0);
    const [totalRequest, setTotalRequest] = React.useState(0);


    useEffect(() => {
      setIsLoading(true);
      handleInitData();

      const timer = setInterval(() => {
        // 注:在setCount中使用箭头函数是最好方式之一,只有一个timer生成
          listenData();

      }, 2000)
      return () => {
        clearInterval(timer)
      }
    },[]);


        
    const listenData = async () => {
      try {
        const data = {
        };

        
        const result = await axios(
            {
                method: "post",
                url: '/faucet-api/random/GetCount',
                // baseURL: "http://127.0.0.1:3001",
                headers: {
                'Content-Type': 'application/json',
                },
                data
            });

        console.log(result.data.res.total)
        setRandomCount(result.data.res.total)


        const data_request = {
        };

        
        const result_request = await axios(
            {
                method: "post",
                url: '/faucet-api/history/GetTotalRequestNum',
                // baseURL: "http://127.0.0.1:3001",
                headers: {
                'Content-Type': 'application/json',
                },
                data: data_request
            });
        setTotalRequest(result_request.data.res.total)
      } catch {
        console.log("api error.");
      }
  };


    
    const handleInitData = async () => {
      try {
        const data = {
            limit: limit,
            offset: page
        };

        const result = await axios(
            {
                method: "post",
                url: '/faucet-api/history/ListHistory',
                // baseURL: "http://127.0.0.1:3001",
                headers: {
                'Content-Type': 'application/json',
                },
                data
            });
        console.log(result.data.res)
        console.log(result.data.res.total)
        let total = result.data.res.total;
        setTotalCount(total);
        let total_page = Math.ceil(total/10) - 1
        setTotalPage(total_page)
        setRequestHistory(result.data.res.data)


      const data_random = {
      };

      
      const result_random = await axios(
          {
              method: "post",
              url: '/faucet-api/random/GetCount',
              // baseURL: "http://127.0.0.1:3001",
              headers: {
              'Content-Type': 'application/json',
              },
              data: data_random
          });
      setRandomCount(result_random.data.res.total)



      const data_request = {
      };

      
      const result_request = await axios(
          {
              method: "post",
              url: '/faucet-api/history/GetTotalRequestNum',
              // baseURL: "http://127.0.0.1:3001",
              headers: {
              'Content-Type': 'application/json',
              },
              data: data_request
          });
      setTotalRequest(result_request.data.res.total)
    } catch {
      console.log("init api error.");
    }
    };
  
    const handlePrevious = async() => {
      try {
        let nowPage = page - 1;
        let nowLimit = 10
        
        console.log("-----11")
        console.log(nowPage, page)
        if (nowPage<=0) {
          nowPage = 0
        }
        console.log(nowPage, page)
        
        const data = {
            offset: nowPage,
            limit: nowLimit
        };
        const result = await axios(
            {
                method: "post",
                url: '/faucet-api/history/ListHistory',
                // baseURL: "http://127.0.0.1:3001",
                headers: {
                'Content-Type': 'application/json',
                },
                data
            });
          console.log(page, limit)

          console.log(result.data.res.data)
          setRequestHistory(result.data.res.data)

          setPage(nowPage)
          setLimit(nowLimit)

          let total = result.data.res.total;
          setTotalCount(total);
          let total_page = Math.ceil(total/10) - 1
          setTotalPage(total_page)

        } catch {
          console.log("previous error");
        }
    }

    const handleNext = async() => {
      try {
        let nowPage = page + 1;
        let nowLimit = limit
        console.log(nowPage, nowLimit)
        if (nowPage>=totalPage) {
          nowPage = totalPage
          nowLimit = totalCount % 10
          
        } else {
          nowLimit = 10
        }
        const data = {
            offset: nowPage,
            limit: nowLimit
        };
        console.log(data)
        const result = await axios(
            {
                method: "post",
                url: '/faucet-api/history/ListHistory',
                // baseURL: "http://127.0.0.1:3001",
                headers: {
                'Content-Type': 'application/json',
                },
                data
            });

          console.log(nowPage, nowLimit)
          console.log(result.data.res.data)
          setRequestHistory(result.data.res.data)
          setPage(nowPage)
          setLimit(nowLimit)

          let total = result.data.res.total;
          setTotalCount(total);
          let total_page = Math.ceil(total/10) - 1
          setTotalPage(total_page)

        } catch {
          console.log("next error");
        }
    }

    const formatTime = (request_at) => {
      const requestTime = new Date(request_at)
        .toLocaleTimeString('zh', {

          year:  "numeric",
          month: "2-digit",
          day:   "2-digit",
          hourCycle: 'h23',
          hour:   '2-digit',
          minute: '2-digit',
          second: '2-digit',
        }).split('/').join('-');
      return requestTime
    }


    if (isLoading) {
        return (

          <div className="tab-pane">
                          <div className='linked-address-head'>
                          Off-chain endpoints               
                          </div>
            <div className="card chain-form-card">
              <tbody className=''>
                <tr className="">
                <th className="chain-name message-detail-font">Available bits</th>
                <th className="chain-name set-width">{randomCount * 256} bits ({randomCount} bytes)</th>
                </tr>
              </tbody>
              
            </div>
            <div className="card chain-form-card">
              <tbody className=''>
                <tr className="">
                <th className="chain-name message-detail-font">Total requests</th>
                <th className="chain-name">{totalRequest} bytes</th>
                </tr>
              </tbody>
              
            </div>
            <div className="card chain-form-card">
              <tbody className=''>
                <tr className="">
                <th className="chain-name message-detail-font">HTTPS</th>
                <th className='chain-name url-link-name link-detail-center'>
                    {httpsLink}
                    <div className='copy-right-1'>
                    <CopyToClipboard
                        text={httpsLink}
                    >
                        <img className='cursor-pointer enable-2fa-copy copy-pointer' src={copy} onClick={CopySuccess}/>
                    </CopyToClipboard>
                    </div>
                    </th>
                </tr>
              </tbody>
            </div>

            <div className="card chain-form-card">
              <tbody className=''>
                <tr className="">
                <th className="chain-name message-detail-font">WebSockets</th>
                    <th className='chain-name url-link-name link-detail-center'>
                    {wssLink}
                    <div className='copy-right-2'>
                    <CopyToClipboard
                        text={wssLink}
                    >
                        <img className='cursor-pointer enable-2fa-copy copy-pointer' src={copy} onClick={CopySuccess}/>
                    </CopyToClipboard>
                    </div>
                    </th>

                </tr>
              </tbody>
            </div>

            { requestHistory.map((request_history, index) => {
            return (
              <div>
              { 
                index === 0 ?
                <>
                  <div className='incentives-history-tips'>
                  </div>
                  <div className='linked-address-head'>
                    Request history
                  </div>
                  <thead className='card-form-head card-detail-form-head'>
                    <tr className=''>
                      <th className="time-name-form-head">TIME</th>
                      <th className="chain-name-form-head">REQUEST ORIGIN</th>
                      <th className="chain-name-form-head">QRNG BYTES</th>
                      <th className="chain-name-form-head">STATUS</th>
                    </tr>
                  </thead>
                </>

                : null
              }
            <div className="card chain-form-card">
              <tbody className=''>
                <tr className="">
                <th className="chain-name time-name">{formatTime(request_history.request_at)}</th>
                <th className="chain-name">{request_history.ip}</th>
                <th className="chain-name">{request_history.number}</th>
                <th className={request_history.status==='Success'? "claimed-status chain-name big-font" : request_history.status==='Fail'? "fail-status chain-name big-font": "expired-status chain-name big-font"}>{request_history.status}</th>
                </tr>
              </tbody>
            </div>
              </div>
            )

          })}

            { requestHistory.length === 0 ?
                <></>
              :
              <div className='page-limit-body'>
                <div className='page-previous' onClick={handlePrevious}>
                  <img src="/data/staking/chevron-left-sm.png"/>
                  Previous
                </div>
                <div className='page-next' onClick={handleNext}>
                  Next 
                <img src="/data/staking/chevron-right-sm.png"/>
                </div>
              </div>
            }
          </div>
        );
  } 
}

export default OffChainTab;
